import gql from 'graphql-tag';

export default gql`
  mutation CreateFacility(
    $data: FacilityCreateInput!
  ) {
    createFacility(
      data: $data
    ) {
      id
      name
      status
      menus
      pdfs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateFacility.ts